import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicDraft({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M11.38 6.08l-7.3 7.3-2.5.27A1.15 1.15 0 01.3 12.38l.27-2.5 7.3-7.3a1.62 1.62 0 012.3 0l1.2 1.2c.63.63.63 1.66 0 2.3zm-2.75.86l-1.6-1.62-5.17 5.17-.2 1.8 1.81-.2 5.16-5.15zm3.67 5.46a.7.7 0 010 1.4h-6a.7.7 0 010-1.4zm3-2.5a.7.7 0 010 1.4h-6a.7.7 0 010-1.4zM8.82 3.52a.3.3 0 01.41 0l1.2 1.2a.3.3 0 010 .42l-.85.85-1.61-1.61z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicDraft.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicDraft.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicDraft svgRef={ref} {...props} />);
export default ForwardRef;
